/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { FieldGroup, FieldSwitch } from "@adapptio/lib-editor-ui";
import { useBlueprintModel } from "../../../ui/hooks/useBlueprintModel";
import { useEditorInspectorContext } from "../../../ui/contexts/EditorInspectorContext";
import { InvalidModelNode } from "../../../ui/components/Inspector/InvalidModelNode";
import { IInspectorControl_Boolean, TInspectorControlProps } from "../InspectorControlTypes";

export interface IInspectorControlBooleanProps extends TInspectorControlProps<IInspectorControl_Boolean> {}

export const InspectorControlBoolean: React.FC<IInspectorControlBooleanProps> = ({ model: _model }) => {
	const editorInspectorCtx = useEditorInspectorContext();
	const { model } = useBlueprintModel(_model, "constBoolean");

	const handleChange = useCallback(
		(value: boolean) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	return (
		<FieldGroup>
			<FieldSwitch
				value={model.value}
				onChange={handleChange}
				readOnly={editorInspectorCtx?.readOnly}
			/>
		</FieldGroup>
	);
};
